if(!customElements.get('recipient-form')){
    class RecipientForm extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.checkbox = this.querySelector('input[type="checkbox"]');
            this.checkbox.disabled = false;
            this.checkbox.checked = false;
            
            this.label = this.querySelector('label[for="'+this.checkbox.getAttribute('id')+'"]');
            this.label.addEventListener('click', this.showRecipientForm.bind(this));
            this.label.addEventListener('keydown', e => {
                if(e.key === 'Enter'){
                    this.showRecipientForm(e);
                }
            })

            this.errorMessage = this.querySelector('.recipient-form__message');

            this.form = this.querySelector('.recipient-form__inputs');

            this.inputWrappers = this.querySelectorAll('.input-wrapper');
            this.inputs = this.querySelectorAll('input, textarea');
            this.inputs.forEach(item => {
                item.addEventListener('focus', this.focusOnInput.bind(this));
                this.addEventListener('focusout', this.focusOutOnInput.bind(this));
            });
        } 

        refresh(){
            this.init();
        }

        showRecipientForm(e){
            if(!this.checkbox.checked){
                this.form.setAttribute('data-hidden', 'false');
                this.label.setAttribute('data-checked', 'true');
                this.errorMessage.setAttribute('data-hidden', 'false');
                this.checkbox.checked = false;
                return;
            }

            this.form.setAttribute('data-hidden', 'true');
            this.label.setAttribute('data-checked', 'false');
            this.errorMessage.setAttribute('data-hidden', 'true');
            this.checkbox.checked = true;
        }

        focusOnInput(e){
            this.inputWrappers.forEach(item => {
                var input = item.querySelector('textarea, input');
                if(input.value.trim() == '') item.setAttribute('data-selected', 'false');
            })

            var currentTarget = e.currentTarget;
            var currentTargetInputWrapper = currentTarget.closest('.input-wrapper');
            currentTargetInputWrapper.setAttribute('data-selected', 'true');
        }

        focusOutOnInput(){
            this.inputWrappers.forEach(item => {
                var input = item.querySelector('textarea, input');
                if(input.value.trim() == '') item.setAttribute('data-selected', 'false');
            })
        }

        reset(){
            this.checkbox.checked = false;
            this.form.setAttribute('data-hidden', 'true');
            this.label.setAttribute('data-checked', 'false');
            this.errorMessage.setAttribute('data-hidden', 'true');

            this.inputWrappers.forEach(item => {
                var input = item.querySelector('textarea, input');
                input.value = '';
                input.setAttribute('value', '');
                item.setAttribute('data-selected', 'false');
            })
        }
    }

    customElements.define('recipient-form', RecipientForm);
}